import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FormOutlined, EyeOutlined } from '@ant-design/icons';
import { Table, Row, Col, Breadcrumb, Typography, Tooltip } from 'antd';
import { intialPaginationState, filter, unexpectedError, showingPageTotalRange } from '../../../common_functions';

const DminSampleAreaList = props => {
  const [dminArea, setDminArea] = useState([]);
  const [pagination, setPagination] = useState(intialPaginationState);
  const [sorter, setSorter] = useState(null);
  const [loading, setLoading] = useState(false);
  const columns = [
    {
      title: 'Sr. No.',
      dataIndex: 'id',
      key: 'id',
      render: (value, item, index) => {
        return (pagination.current - 1) * pagination.pageSize + index + 1;
      },
    },
    {
      title: 'Dmin Sample Area',
      dataIndex: 'dmin_sample_area',
      key: 'dmin_sample_area',
      sorter: true,
      render: (text, record) => <span style={{ textTransform: 'capitalize' }}>{record.dmin_sample_area}</span>,
      ...filter('dmin_sample_area'),
    },
    {
      title: 'Actions',
      key: 'action',
      render: (text, record) => (
        <span>
          <div className="actionbtngroup">
            <Link to={'/settings/dmin-sample/edit/' + record.id}>
              <Tooltip
                placement="top"
                title={props.roleType === 'admin' || props?.tabs_permissions?.settings_dmin_sample?.edit ? 'Edit' : 'View'}
              >
                <button className="edit-btn">
                  {props.roleType === 'admin' || props?.tabs_permissions?.settings_dmin_sample?.edit ? <FormOutlined /> : <EyeOutlined />}
                </button>
              </Tooltip>
            </Link>
            {props.deleteRecord(
              props,
              record.id,
              'dmin_sample_area',
              'Dmin sample area?',
              dminArea,
              setDminArea,
              props?.tabs_permissions?.settings_dmin_sample?.delete
            )}
          </div>
        </span>
      ),
    },
  ];
  //Get collection data
  useEffect(() => {
    (async () => {
    await getDminSampleData(pagination);
  })();
  }, []);

  const getDminSampleData = async (pagination, filters = {}, sorter = '') => {
    setLoading(true);
    try {
      const response = await props.getItems('dmin_sample_area', {
        fields: ['*,dmin_sample_area'],
        sort: !!sorter && sorter.field ? (sorter.order === 'ascend' ? '' : '-') + sorter.field : '-id',
        filters: filters,
        offset: pagination.pageSize * (pagination.current - 1),
        limit: pagination.pageSize,
        meta: 'filter_count',
      });
      pagination.total = response.meta.filter_count;
      setPagination(pagination);
      setDminArea(response.data);
    } catch (error) {
      unexpectedError(error);
    } finally {
      setLoading(false);
    }
  };

  const handleTableChange = async (pagination, filters, sorter) => {
    setPagination(pagination);
    setSorter(sorter);
    setLoading(true);
    let filtersitems = {};
    for (let key in filters) {
      if (filters.hasOwnProperty(key)) {
        let val = filters[key];
        if (val) {
          if (key == 'artist') {
            filtersitems['_or'] = [{ artist: { last_name: { _icontains: val[0] } } }, { artist: { First_Name: { _icontains: val[0] } } }];
          } else {
            filtersitems[key] = { _icontains: val[0] };
          }
        }
      }
    }
    await getDminSampleData(pagination, filtersitems, sorter);
  };
  return (
    <Row>
      <Col span={24} className="app-breadcrumb-col">
        <Breadcrumb items={[{ title: "Settings", href: "/settings/dmin-sample" }, { title: "Dmin Sample Area" }]} />
      </Col>
      <Col className="white-paper" span={24}>
        <div className="dashboard">
          <Row gutter={24} className="page-header-section" align="middle">
            <Col xs={12}>
              <Typography.Title level={4} style={{ margin: 0 }}>
                View Dmin Sample Area
              </Typography.Title>
            </Col>
            <Col xs={12} justify="end">
              {props.createButton(
                props.roleType,
                props.tabs_permissions.settings_dmin_sample,
                `/settings/dmin-sample/new`,
                'Create Dmin Sample Area'
              )}
            </Col>
          </Row>
          <hr />
          <div className="artist-list">
            <Table
              scroll={{ x: 'max-content' }}
              columns={columns}
              bordered
              rowKey={record => record.id}
              dataSource={dminArea}
              pagination={{ ...pagination, ...showingPageTotalRange }}
              loading={loading}
              onChange={handleTableChange}
            />
          </div>
        </div>
      </Col>
    </Row>
  );
};

export default DminSampleAreaList;
